import type React from "react";
import styles from "./DrawingTools.module.css";

import CropSquareOutlinedIcon from "@mui/icons-material/CropSquareOutlined";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

type DrawingToolsProps = {
    // рисование
    drawMode?: "idle" | "drawing" | "editing";
    selectedShapeId?: string | null;
    onStartPolygon?: () => void;
    onFinish?: () => void;
    onCancel?: () => void;
    onDelete?: () => void;
};

export default function DrawingTools({
    drawMode = "idle",
    selectedShapeId = null,
    onStartPolygon,
    onFinish,
    onCancel,
    onDelete,
}: DrawingToolsProps) {
    const canFinishOrCancel = drawMode === "drawing" || drawMode === "editing";

    return (
        <div className={styles.bar}>
            <LayerButton
                icon={<CropSquareOutlinedIcon fontSize="small" />}
                title="Нарисовать геозону"
                active={false}
                onClick={() => onStartPolygon?.()}
            />

            {canFinishOrCancel && (
                <>
                    <LayerButton
                        icon={<DoneOutlinedIcon fontSize="small" />}
                        title="Сохранить (завершить)"
                        active={false}
                        onClick={() => onFinish?.()}
                    />
                    <LayerButton
                        icon={<CloseOutlinedIcon fontSize="small" />}
                        title="Отмена"
                        active={false}
                        onClick={() => onCancel?.()}
                    />
                </>
            )}

            {!!selectedShapeId && drawMode === "idle" && (
                <LayerButton
                    icon={<DeleteOutlineOutlinedIcon fontSize="small" />}
                    title="Удалить выбранную фигуру"
                    active={false}
                    onClick={() => onDelete?.()}
                />
            )}
        </div>
    );
}

function LayerButton({
    icon,
    title,
    active,
    onClick,
}: {
    icon?: React.ReactNode;
    title: string;
    active: boolean;
    onClick: () => void;
}) {
    return (
        <button
            type="button"
            className={`${styles.btn} ${active ? styles.active : ""}`}
            onClick={(e) => {
                e.stopPropagation();
                onClick();
            }}
            aria-label={title}
        >
            {icon}

            <span className={styles.tooltip} role="tooltip">
                {title}
            </span>
        </button>
    );
}
